export default {
  namespaced: true,
  state: {
    cart: [],
    promocode: null,
    /*
      discount - Фиксированная сумма
      percent - Скидка в процентах
    */
  },

  getters: {
    getNumberOfProductsInCart: function(state) {
      return state.cart.length;
    },
    getSumCart: function(state) {
      return state.cart.reduce(
        (sum, currentItem) =>
          (sum += parseInt(currentItem.price) * currentItem.count),
        0
      );
    },
    getSummaryCart: function(state, getters) {
      return {
        old: getters.getDiscount ? getters.getSumCart : null,
        new: state.cart.length
          ? getters.getSumCart - getters.getDiscount
          : getters.getSumCart,
      };
    },
    checkInCart: (state) => (id) => {
      return !!state.cart.filter((item) => item.id === id)[0];
    },
    isPromocodeActive: function(state) {
      return !!state.promocode;
    },
    getDiscount: function(state, getters) {
      let value = 0;

      if (state.promocode) {
        switch (state.promocode.type) {
          case 'discount':
            value = state.promocode.value;
            break;
          case 'percent':
            value = (getters.getSumCart * state.promocode.value) / 100;
            break;
          default:
            break;
        }
      }

      return value;
    },
    getDiscountFormat: function(state, getters) {
      return getters.getDiscount.toLocaleString();
    },
    getCartItem: (state) => (id) => {
      const result = state.cart.find((item) => item.id == id.trim());
      return result ? result : null;
    },
  },
  mutations: {
    addItemToCart: function(state, product) {
      let filterResult = state.cart.filter((item) => item.id === product.id)[0];

      filterResult
        ? (filterResult.count = product.count)
        : state.cart.push(product);
    },
    removeFromCart: function(state, id) {
      state.cart = state.cart.filter((item) => item.id !== id);
    },
    setPromocode: function(state, data) {
      state.promocode = { ...data };
    },
    clearPromocode: function(state) {
      state.promocode = null;
    },
    clearCart: function(state) {
      state.cart = [];
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/cart.js